import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class Autogrow extends Component {

    prepare() {
        this.element.addEventListener('input', this.handleInput)
        Scroll.on('resize', this.handleResize)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleInput = event => {
        this.resize()
    }

    handleResize = event => {
        this.resize()
    }

    resize() {
        if (this.element.scrollHeight > this.element.offsetHeight) {
            this.element.style.height = `${this.element.scrollHeight + 2}px` // + border width
        }

        if (this.element.value.trim() === '') {
            this.element.removeAttribute('style')
        }
    }

}
